<div class="container">
  <div class="container__left">
    <ts-input
      [formControl]="searchInputControl"
      type="text"
      icon="ts_search"
      size="sm"
      class="max-h-ts-input-list-search w-ts-input-list-search"
      placeholder="Search"
    ></ts-input>

    <ts-button
      type="stroked"
      color="accent"
      class="xs:hidden"
      icon="visibility"
      [matTooltip]="'Select columns'"
      [tsOverlayTriggerFor]="columnsSelectOverlayBox"
    >
      Fields
      @if (columns.length) {
        <ts-badge [value]="columns.length" [type]="'info'"></ts-badge>
      }
    </ts-button>

    @if ((featureSupport$ | async)?.bulkActions?.enabled && selectedRows?.length > 0) {
      <ts-button type="stroked" color="accent" [matMenuTriggerFor]="bulkMenu" [matTooltip]="'Open Mass Update Menu'">
        Update Selected
      </ts-button>
      <mat-menu #bulkMenu>
        @if ((featureSupport$ | async)?.bulkActions?.actions?.updateTags) {
          <button mat-menu-item (click)="onOpenTagsBulkUpdate()">
            <ts-icon icon="label" color="gray"></ts-icon> Update Tags
          </button>
        }
      </mat-menu>
    }

    <ts-button
      type="stroked"
      color="accent"
      class="xs:hidden"
      icon="ts_filter-list"
      [matTooltip]="'Apply filters'"
      [tsOverlayTriggerFor]="filtersOverlayBox"
    >
      Filter
      @if (filterValueList.length) {
        <ts-badge [value]="filterValueList.length" [type]="'info'"></ts-badge>
      }
    </ts-button>

    @if ((featureSupport$ | async)?.tags?.enabled) {
      <ts-button
        type="stroked"
        color="accent"
        class="xs:hidden"
        icon="ts_tag"
        [tsOverlayTriggerFor]="tagsOverlayBox"
        [matTooltip]="'Filter by tags'"
      >
        Tags
        @if (tagsList?.length) {
          <ts-badge [value]="tagsList?.length" [type]="'info'"></ts-badge>
        }
      </ts-button>
    }
  </div>

  <div class="container__right">
    @if (PermissionSlot.PUBLIC_CUSTOM_VIEWS | jupiterPermissionSlot | hasPermission) {
      <ts-menu [items]="viewActions" />
    }
  </div>
</div>

<ts-overlay
  #columnsSelectOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onColumnSelectClosedByBackdropClick()"
>
  <div class="field-selection">
    <div class="field-selection__search-container">
      <mat-icon svgIcon="search"></mat-icon>
      <input type="text" placeholder="Enter field name" maxLength="50" [(ngModel)]="searchInput" />
    </div>
    <div class="field-selection__results">
      @for (
        filteredField of fieldDefs
          | filterBy: ['label'] : searchInput
          | groupBy: '_parentFieldName' : '_parentFieldLabel';
        track $index
      ) {
        @if (filteredField?.groupLabel?.length > 1) {
          <p class="py-2 font-bold text-gray-default">
            {{ filteredField?.groupLabel }}
          </p>
        }
        @for (item of filteredField.items; track $index) {
          @if (filteredField?.groupLabel?.length > 1 || item?.type !== 'record') {
            <p class="py-0.5">
              <mat-checkbox
                [ngClass]="{ 'pl-3': filteredField?.groupLabel?.length > 1 }"
                [disabled]="columns.length < 2 && columns.includes(item?.name)"
                [color]="'primary'"
                [checked]="columns.includes(item?.name)"
                (change)="toggleDisplayColumn(item?.name, $event)"
              >
                {{ item.label }}
              </mat-checkbox>
            </p>
          }
        }
      }
    </div>
  </div>
</ts-overlay>

<ts-overlay
  #filtersOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onFilterClosedByBackdropClick()"
>
  <ts-filter
    size="large"
    [fields]="fieldDefs"
    [filters]="filterValueList"
    [lookupContract]="lookupService"
    [hasGroups]="true"
    (addItem)="onAddFilterItem()"
    (filterDefChange)="onFilterDefChanged($event)"
    (filterRemove)="onFilterRemoved($event)"
    (filterClear)="onFilterCleared()"
    (filterApply)="onFilterApplied()"
  ></ts-filter>
</ts-overlay>

<ts-overlay #tagsOverlayBox position="bottom" [transparentBackdrop]="true">
  @if ((featureSupport$ | async)?.tags?.enabled) {
    <app-tags-panel
      (tagsUpdated)="onTagsUpdated($event)"
      [queryFilters]="{ tags: tagsList }"
      [relatedToType]="relatedTo$ | async"
    ></app-tags-panel>
  }
</ts-overlay>
